<p-fluid>
    <form [formGroup]="form" class="flex flex-col gap-2">
        <div class="flex flex-col">
            <label for="tipoRepresentacao">
                Tipo Representação<span class="required">*</span>
            </label>
            <p-select
                    (onChange)="onChangeTipoRepresentacao($event)"
                    [filter]="true"

                    [options]="tipoRepresentacaoOptions"
                    appendTo="body"
                    class="w-full"
                    filterBy="label"
                    formControlName="tipoRepresentacao"
                    id="tipoRepresentacao"
                    placeholder="Selecione"
            />
            @if (form.get('tipoRepresentacao')?.invalid && form.get('tipoRepresentacao')?.touched) {
                <small
                        class="required text-sm">Tipo Representação é obrigatório.</small>
            }
        </div>

        @if (showForm) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <p-divider class="sm:col-span-2"/>

                <div class="flex flex-col">
                    <label for="email">
                        E-mail<span class="required">*</span>
                    </label>
                    <input class="w-full"
                           formControlName="email"
                           id="email"
                           maxlength="255"
                           pInputText placeholder="Digite">
                    @if (form.get('email')?.invalid && form.get('email')?.touched) {
                        @if (form.get('email')?.errors?.['required']) {
                            <span class="required text-sm">E-mail é obrigatório.</span>
                        } @else {
                            <span class="required text-sm">E-mail inválido.</span>
                        }
                    }
                </div>

                @if (form.get('tipoRepresentacao')?.value?.nome === TipoRepresentacao.SCO) {
                    <div class="flex flex-col">
                        <label for="cnpj">
                            CNPJ da Organização<span class="required">*</span>
                        </label>
                        <p-input-mask
                                [maxlength]="18"
                                class="w-full"
                                formControlName="cnpj"
                                id="cnpj"
                                mask="99.999.999/9999-99"
                                placeholder="Digite"/>
                        @if (form.get('cnpj')?.invalid && form.get('cnpj')?.touched) {
                            <small
                                    class="required text-sm">CNPJ da Organização é obrigatório.</small>
                        }
                    </div>
                }

                <div class="flex flex-col">
                    <label for="nomeOrganizacao">
                        {{ labelFormControlNome }}<span class="required">*</span>
                    </label>
                    <input
                            class="w-full"
                            formControlName="nomeOrganizacao"
                            id="nomeOrganizacao"
                            maxlength="255"
                            pInputText placeholder="Digite">
                    @if (form.get('nomeOrganizacao')?.invalid && form.get('nomeOrganizacao')?.touched) {
                        <small
                                class="required text-sm">{{ labelFormControlNome }} é obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col">
                    <label for="cargo">
                        Cargo<span class="required">*</span>
                    </label>
                    <input class="w-full"
                           formControlName="cargo"
                           id="cargo"
                           maxlength="255"
                           pInputText placeholder="Digite">
                    @if (form.get('cargo')?.invalid && form.get('cargo')?.touched) {
                        <small
                                class="required text-sm">Cargo é obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col">
                    <label for="cep">
                        CEP<span class="required">*</span>
                    </label>
                    <p-inputmask
                            [maxlength]="10"
                            class="w-full"
                            formControlName="cep"
                            id="cep"
                            mask="99.999-999"
                            placeholder="Digite"/>
                    @if (form.get('cep')?.invalid && form.get('cep')?.touched) {
                        <small
                                class="required text-sm">CEP é obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col">
                    <label for="logradouro">
                        Logradouro<span class="required">*</span>
                    </label>
                    <input class="w-full"
                           formControlName="logradouro"
                           id="logradouro"
                           maxlength="255"
                           pInputText
                           placeholder="Digite">
                    @if (form.get('logradouro')?.invalid && form.get('logradouro')?.touched) {
                        <small
                                class="required text-sm">Logradouro é obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col">
                    <label for="numero">
                        Número<span class="required">*</span>
                    </label>
                    <p-input-number
                            [maxlength]="10"
                            [useGrouping]="false"
                            class="w-full"
                            fluid
                            formControlName="numero"
                            id="numero" placeholder="Digite"/>
                    @if (form.get('numero')?.invalid && form.get('numero')?.touched) {
                        <small
                                class="required text-sm">Número é obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col">
                    <label for="complemento">
                        Complemento
                    </label>
                    <input class="w-full"
                           formControlName="complemento"
                           id="complemento"
                           maxlength="255"
                           pInputText placeholder="Digite">
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-6 gap-2 sm:col-span-2">
                    <div class="flex flex-col sm:col-span-3">
                        <label for="bairro">
                            Bairro<span class="required">*</span>
                        </label>
                        <input class="w-full"
                               formControlName="bairro"
                               id="bairro"
                               maxlength="255"
                               pInputText
                               placeholder="Digite">
                        @if (form.get('bairro')?.invalid && form.get('bairro')?.touched) {
                            <small
                                    class="required text-sm">Bairro é obrigatório.</small>
                        }
                    </div>
                    <div class="flex flex-col sm:col-span-2">
                        <label for="municipio">
                            Cidade<span class="required">*</span>
                        </label>
                        <input class="w-full"
                               formControlName="municipio"
                               id="municipio"
                               maxlength="50"
                               pInputText
                               placeholder="Digite">
                        @if (form.get('municipio')?.invalid && form.get('municipio')?.touched) {
                            <small
                                    class="required text-sm">Cidade é obrigatório.</small>
                        }
                    </div>
                    <div class="flex flex-col sm:col-span-1">
                        <label for="uf">
                            UF<span class="required">*</span>
                        </label>
                        <input class="w-full"
                               formControlName="uf"
                               id="uf"
                               maxlength="2"
                               pInputText
                               placeholder="Digite">
                        @if (form.get('uf')?.invalid && form.get('uf')?.touched) {
                            <small
                                    class="required text-sm">UF é obrigatório.</small>
                        }
                    </div>
                </div>

                <div class="flex flex-col col-span-full">
                    <label for="arquivo">
                        {{ labelFormControlArquivo }}@if (isRequiredFormControlArquivo) {
                        <span class="required">*</span>
                    }
                    </label>

                    @if (form.get('arquivo')?.value) {
                        <div class="flex flex-row bg-[#E4E7EB] rounded justify-between items-center w-full p-4 pr-8">
                            <div class="flex gap-2 items-center">
                                <app-icon-bold-document-download color="#5A5C69"/>
                                <div class="break-words">{{ file?.name }}</div>
                            </div>
                            <div class="flex gap-2 items-center">
                                <p-button
                                        (click)="onRemoveFile()"
                                        (keydown.space)="$event.preventDefault(); onRemoveFile()"
                                        (keydown.enter)="$event.preventDefault(); onRemoveFile()"
                                        pTooltip="Excluir"
                                        styleClass="btn-icon"
                                        tooltipPosition="bottom">
                                    <app-icon-bold-trash color="var(--color-primary)"/>
                                </p-button>
                            </div>
                        </div>
                    } @else {
                        <p-fileupload
                                (onSelect)="onSelectArquivo($event)"
                                [multiple]="false"
                                [showCancelButton]="false"
                                [showUploadButton]="false"
                                chooseLabel="Selecione"
                                chooseStyleClass="btn-red shrink-0"
                                class="w-full"
                                name="fileInput"
                                styleClass="!flex !flex-row !items-center !text-[#858796]">
                            <ng-template pTemplate="chooseicon">
                                <app-icon-bold-document-upload color="currentColor"/>
                            </ng-template>
                            <ng-template pTemplate="content">
                                @if (!fileTooLarge && !fileInvalidExtension) {
                                    <div class="text-sm min-w-0">Formatos permitidos: PDF, JPG, JPEG, PNG ou BMP</div>
                                } @else if (fileTooLarge) {
                                    <span
                                            class="text-sm text-primary min-w-0">Tamanho do arquivo não permitido. Somente arquivos até {{ getFormattedFileSize() }}</span>
                                } @else {
                                    <span class="text-sm text-primary min-w-0">Formatos permitidos: PDF, JPG, JPEG, PNG ou BMP</span>
                                }
                            </ng-template>
                            <ng-template pTemplate="file"></ng-template>
                        </p-fileupload>
                        @if (form.get('arquivo')?.invalid && form.get('arquivo')?.touched) {
                            <small
                                    class="required text-sm">{{ labelFormControlArquivo }} é obrigatório.</small>
                        }
                    }
                </div>
            </div>

            @if (mode === 'reforcar') {
                <p-divider class="sm:col-span-2"/>
            }
        }
    </form>
</p-fluid>
